module.exports = __webpack_public_path__ + "images/logo-0818d1c8.png";